import { Dialog } from '@angular/cdk/dialog';
import { CommonModule, DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { OrderItem } from 'src/_lib/interfaces/cart-data.interface';
import { AuthHttpService } from 'src/_lib/service/auth-http.service';
import { CartService } from 'src/_lib/service/cart.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { OffcanvasService } from 'src/_lib/service/offcanvasslide.service';
import { AppConstants } from 'src/app/app.constants';
import { CustomerLoginComponent } from 'src/app/templates/customer-login/customer-login.component';
import { environment } from 'src/environments/environment.prod';
import { LoaderServiceService } from 'src/_lib/service/loader-service.service';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { GtmService } from 'src/_lib/service/gtm.service';
import { CartVerifyPopupComponent } from 'src/app/templates/cart/component/cart-verify-popup/cart-verify-popup.component';
import { BrowserService } from 'src/_lib/service/browser.service';
import { SignUpComponent } from 'src/app/templates/sign-up/sign-up.component';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss'],
  standalone: true,
  imports: [RouterLink, CommonModule, FormsModule],
})
export class ShoppingCartComponent {
  firstObj: number = this.appConstants.firstObj;
  order_key: number;
  errorMsg: string;
  quantity: any[] = [];
  calculated_price: any[];
  singleItemPrice: number;
  totalAmount: number;
  orderItemsData: OrderItem[] = [];
  cdnImgPath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  totalItems: number = 0;
  modalDialog: any;
  country_code: string = 'US';
  removeItemMsg: boolean = false;
  promotionalPrice = [];
  savedAmount = [];
  promotions: any;
  freeShippingPromotions: any[];
  isFreeShippingcontains: boolean;
  bannerImage: any;
  shouldShowPromotion: boolean;
  allPromotionProducts: any;
  minQtyAllowed: any;
  newLineMinProdQty: any;
  responseData: any;
  freeShippingPromotionApplied: boolean;
  discountData: any;
  carttotalQty: number;
  freeShippingMinProductPrice: number;
  remainingAmount: number;
  freeShippingMessage: string;
  isLoading: boolean = false;

  @ViewChild('shoppingCartOffcanvas', { static: false }) cartEl!: ElementRef;
  private openCartListener: any;
 private hideCartListener: any;
 private offcanvasHideListener: any;

  constructor(
    private appConstants: AppConstants,
    private offcanvasService: OffcanvasService,
    private comm: CommunicationService,
    private cartHttp: CartService,
    private dialog: MatDialog,
    private dialogre: Dialog,
    private router: Router,
    private authHttpService: AuthHttpService,
    private renderer: Renderer2,
    private loader: LoaderServiceService,
    private commonService: CommanpageService,
    private gtmService: GtmService,
    private browser: BrowserService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.setRendererStyle()
    this.order_key = +this.browser.localStorage?.getItem('orderId');
    if (this.order_key) {
      this.getCartList();
    } else {
      this.orderItemsData = [];
      this.errorMsg = 'Your Cart Is Empty';
    }
    this.totalItems = +this.browser.localStorage?.getItem('ItemCount') || null;
  }

ngAfterViewInit() {
  if (!this.browser.isBrowser) return;
  const win = this.browser.window;
  const doc = this.browser.doc;
  if (!win || !doc) return;
  this.registerCartOffcanvas();
  this.openCartListener = () => {
    this.setRendererStyle();
    this.order_key = +this.browser.localStorage?.getItem('orderId');
    if (this.order_key) {
      this.getCartList();
    } else {
      this.errorMsg = 'Your Cart Is Empty';
      this.orderItemsData = [];
    }
  };
  win.addEventListener('open-shopping-cart', this.openCartListener);
  const cartOffcanvas = doc.getElementById('shoppingCartOffcanvas');
  if (cartOffcanvas) {
    this.offcanvasHideListener = () => {
      doc.querySelectorAll('.offcanvas-backdrop').forEach((el: any) => el.remove());
      doc.body.classList.remove(
        'offcanvas-backdrop',
        'show',
        'modal-open'
      );
    };
    cartOffcanvas.addEventListener(
      'hide.bs.offcanvas',
      this.offcanvasHideListener
    );
  }
  this.hideCartListener = () => {
    this.renderer.removeStyle(doc.documentElement, 'overflow');
  };
  win.addEventListener('hide.bs.offcanvas', this.hideCartListener);
}

  setRendererStyle() {
    if (typeof document !== 'undefined') {
    this.renderer.setStyle(this.document.documentElement, 'overflow', 'hidden');
    }
  }

  closeCartOffcanvas() {
    if (typeof document !== 'undefined') {
    this.offcanvasService.close('shoppingCartOffcanvas');
    this.renderer.removeStyle(this.document.documentElement, 'overflow');
    }
  }

  async registerCartOffcanvas(): Promise<void> {
    const bootstrap = await import('bootstrap');
    if (this.cartEl?.nativeElement) {
      this.offcanvasService.register(
        'shoppingCartOffcanvas',
        this.cartEl.nativeElement
      );
    }
  }

  async getCartList() {
    if (this.order_key) {
      this.isLoading = true;
      this.cartHttp.cart(this.order_key).subscribe({
        next: (response) => {
          this.comm.setCartData(response);
          this.errorMsg = null;
          if (response[this.firstObj]?.success == true) {
            this.cartHttp.initializeOrderItemsList();
            this.isLoading = false;
            this.orderItemsData =
              response[this.firstObj].data[this.firstObj].order_items;
            this.cartHttp.setCartShippingType(response[this.firstObj]?.data[this.firstObj]?.is_freight_shipping == 1);
            this.quantity = this.orderItemsData.map((item) => item.qty ?? 1);
            this.calculated_price = this.orderItemsData.map(
              (item) => item.final_price
            );
            this.orderItemsData = this.orderItemsData.map((item: OrderItem) => ({
              ...item, product_name: item.product_name?.replace(/\\/g, '') || ''}))
            this.totalAmount = this.calculated_price
              .map(Number)
              .reduce((acc: number, item: any) => acc + item, 0);
            this.calculatePromotion();
            this.getPromotionProducts();
            this.calculateTotalItems(this.orderItemsData);
            if (this.orderItemsData?.length > 0) {
              this.orderItemsData.map(
                (item: { product_variation_key: number; qty: number }) => {
                  this.cartHttp.setOrderItemsList(
                    item.product_variation_key,
                    item.qty
                  );
                }
              );
              this.cartHttp.setLocalStorageOrderItemsList();
              this.gtmService.pushEvent('view_cart', {
                ecommerce: {
                  currency: 'USD',
                  value: this.totalAmount,
                  items: this.orderItemsData.map((item: any) => ({
                    item_id: item?.product_variation_key,
                    item_name: item?.product_name,
                    item_brand: item?.product_brand?.brand_name,
                    item_category: item?.product_cat?.category?.name,
                    price: Number(item?.final_price) / Number(item?.qty),
                    quantity: Number(item?.qty)
                  }))
                }
              });
            } else {
              this.cartHttp.initializeOrderItemsList();
              this.cartHttp.setLocalStorageOrderItemsList();
            }
            if (this.orderItemsData?.length <= 0) {
              this.orderItemsData = [];
              this.calculateTotalItems(this.orderItemsData);
              this.OnEmptyOrders();
            }
          } else if (response[this.firstObj]?.success == false) {
            this.orderItemsData = [];
            this.calculateTotalItems(this.orderItemsData);
            this.errorMsg = 'Your Cart Is Empty';
            this.OnEmptyOrders();
          }
          this.isLoading = false;
        },
      });
    }
  }

  getPromotionProducts() {
    this.cartHttp.ProductPromotionData().subscribe(
      (response: any) => {
        if (response && response[this.firstObj]?.code === 200) {
          const promotions = response[this.firstObj]?.data || [];
          this.bannerImage = promotions[this.firstObj]?.banner_image;
          this.freeShippingPromotions = [];
          this.shouldShowPromotion = false;
          this.isFreeShippingcontains = false;
          this.allPromotionProducts = [];
          promotions.forEach((promotion: any) => {
            if (promotion.promotion_type === 'cart_promotion') {
              const minProductPrice = parseFloat(promotion.minimum_product_price || '0');
              const minQuantity = parseInt(promotion.minimum_quantity || '0', 10);
              this.shouldShowPromotion =
                minProductPrice > 0 &&
                this.totalItems >= minQuantity &&
                this.totalAmount > 0 &&
                this.orderItemsData?.length > 0;
              this.discountData = promotion.percentage_discount;
              this.allPromotionProducts.push(...(promotion.promotion_products || []));
            } else if (promotion.promotion_type === 'free_shipping' && !this.isFreeShippingcontains) {
              this.freeShippingMinProductPrice = parseFloat(promotion.minimum_product_price || '0');
              const freeShippingMinQuantity = parseInt(promotion.minimum_quantity || '0', 10);
              this.isFreeShippingcontains = true;
              if (this.totalAmount >= this.freeShippingMinProductPrice && this.totalItems >= freeShippingMinQuantity) {
                this.freeShippingPromotionApplied = true;
              }
              this.handleFreeShippingPromotion();
            }
          });
        } else {
          console.error('Product promotion request failed.');
        }
      },
      (error: any) => {
        console.error('Error fetching promotions:', error);
      }
    );
  }

  handleFreeShippingPromotion(): void {
    if (this.orderItemsData?.length > 0) {
      const minAmountForFreeShipping = this.freeShippingMinProductPrice;
      const totalAmount = this.totalAmount;
      this.remainingAmount = minAmountForFreeShipping - totalAmount;
      if (totalAmount >= minAmountForFreeShipping) {
        this.updateFreeShipping(true);
        this.remainingAmount = 0;
      } else {
        this.remainingAmount = minAmountForFreeShipping - totalAmount;
      }
    } else {
      console.error('Invalid index or empty orderItemsData.');
    }
  }

  updateFreeShipping(isFreeShipping: boolean): void {
    const orderKey =
      this.orderItemsData?.length > 0
        ? this.orderItemsData[this.firstObj].order_key
        : null;
    if (orderKey) {
      this.cartHttp
        .updateFreeShippingStatus(orderKey, isFreeShipping)
        .subscribe({
          error: (error) => {
            console.error('Error updating cart for free shipping:', error);
          },
        });
    }
  }

  removeCartItem(
    order_item_key: number,
    order_key: number,
    product_variation_key: number,
    qty: number,
    price: number,
    final_price?: number,
    product_name?: string
  ) {
    const product = this.orderItemsData.find(
      (item) => item.product_variation_key === product_variation_key
    );
    const brandName = product?.product_brand?.brand_name;
    const categoryName = product?.product_cat?.category?.name;
    const is_custom = product_variation_key === 0;
    const orderData = {
      order_key: order_key,
      order_item_key: order_item_key,
      product_variation_key: product_variation_key,
      qty: qty,
      price: is_custom ? final_price ?? price : price,
      is_custom,
    };
    this.isLoading = true;
    this.cartHttp.removeToCart(orderData).subscribe({
      next: async (response) => {
        this.comm.itemCount.next(null);
        if (response[this.firstObj].success == true) {
          this.gtmService.pushEvent('remove_from_cart', {
            ecommerce: {
              currency: 'USD',
              value: Number(is_custom ? final_price ?? price : price) * qty,
              items: [
                {
                  item_id: product_variation_key,
                  item_name: product_name,
                  item_brand: brandName,
                  item_category: categoryName,
                  price: Number(is_custom ? final_price ?? price : price),
                  quantity: qty
                }
              ]
            }
          });
          this.getCartList();
          this.comm.removeUpshellsProductFromCart(product_variation_key);
          this.comm.removeCartPromotionProductFromCart(product_variation_key);
          this.cartHttp.removeOrderFromOrderItemsList(product_variation_key);
          this.browser.localStorage?.setItem('ItemCount', String(this.totalItems));
          this.comm.itemCount.next(null);
          this.browser.localStorage?.removeItem('checkoutArray');
          this.comm.emitCartItemRemoved(true);
          if (this.router.url === '/cart') {
            this.reloadcartpage();
          }
          if (this.quantity?.length <= 1 && this.router.url === '/checkout') {
            this.router.navigate(['/cart']);
          } else if (this.quantity?.length > 1 && this.router.url === '/checkout') {
            this.reloadcheckoutpage();
          }
          this.removeItemMsg = true;
          setTimeout(() => {
            this.removeItemMsg = false;
          }, 900);
        }
      },
      error: (error) => {
        this.isLoading = false;
      },
    });
  }

  calculatePrice() {
    this.calculated_price = [];
    if (this.orderItemsData?.length > 0) {
      for (let i = 0; i < this.orderItemsData?.length; i++) {
        const qty = Number(this.orderItemsData[i]?.qty);
        const final_price = Number(this.orderItemsData[i]?.final_price);
        this.singleItemPrice = final_price / qty;
        this.calculated_price[i] = this.singleItemPrice * this.quantity[i];
      }
      this.totalAmount = this.calculated_price.reduce(
        (acc: number, item: any) => acc + item,
        0
      );
      return this.calculated_price;
    } else {
      console.warn('No items to calculate.');
    }
    return this.calculated_price;
  }

  calculateTotalItems(orderItemsData: any) {
    if (orderItemsData?.length > 0) {
      this.totalItems = 0;
      orderItemsData.map((item: { qty: string }) => {
        this.totalItems = this.totalItems + Number(item.qty);
      });
    } else {
      this.totalItems = 0;
    }
    this.browser.localStorage?.setItem('ItemCount', String(this.totalItems));
    this.comm.itemCount.next(null);
  }

  async getUpdateCartqty(
    quantity: number,
    order_key: number,
    order_item_key: number,
    product_variation_key: number,
    final_price: number
  ) {
    this.loader.show();
    let inputqtyValue: number = quantity;
    let qty: number = inputqtyValue;
    if (inputqtyValue !== undefined && inputqtyValue !== null) {
      if (qty == 0) {
        this.removeCartItem(
          order_item_key,
          order_key,
          product_variation_key,
          0,
          final_price
        );
        return;
      }
      const is_custom = product_variation_key === 0;
      const qtyupdate = {
        order_key: order_key,
        order_item_key: order_item_key,
        product_variation_key: product_variation_key,
        qty: qty,
        price: final_price,
        is_custom: is_custom,
      };
      this.cartHttp.updateCart(qtyupdate).subscribe({
        next: async () => {
          if (qty == 0) {
            this.orderItemsData = this.orderItemsData.filter(
              (item) => order_item_key != item.order_item_key
            );
            this.cartHttp.removeOrderFromOrderItemsList(product_variation_key);
          } else {
            this.cartHttp.setOrderItemsList(product_variation_key, qty);
            this.getCartList();
          }
          if (this.router.url === '/cart') {
            this.reloadcartpage();
          } if (this.router.url === '/checkout') {
            this.reloadcheckoutpage();
          }
          this.dialogre.closeAll();
          this.loader.hide();
        },
      });
    }
  }

  reloadcartpage() {
    const prevReuse = this.router.routeReuseStrategy.shouldReuseRoute;
    const prevSameUrl = this.router.onSameUrlNavigation;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl('/cart').finally(() => {
      this.router.routeReuseStrategy.shouldReuseRoute = prevReuse;
      this.router.onSameUrlNavigation = prevSameUrl;
    });
  }

  reloadcheckoutpage() {
    const prevReuse = this.router.routeReuseStrategy.shouldReuseRoute;
    const prevSameUrl = this.router.onSameUrlNavigation;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl('/checkout').finally(() => {
      this.router.routeReuseStrategy.shouldReuseRoute = prevReuse;
      this.router.onSameUrlNavigation = prevSameUrl;
    });
  }

  getCartVerify() {
    const verifydata = {
      order_key: +this.browser.localStorage?.getItem('orderId'),
      country_code: this.country_code,
    };
    if (this.order_key) {
      this.cartHttp.getCartVerify(verifydata).subscribe({
        next: (response) => {
          const notifications =
            response[this.firstObj]?.data?.notification_message;
            const proccedToCheckout = response[this.firstObj]?.data?.proceed_to_checkout
          if (notifications?.includes('Discount code removed successfully')) {
            this.browser.localStorage?.removeItem('discountCode');
            this.browser.localStorage?.removeItem('discountedValue');
            this.browser.localStorage?.removeItem('discountedAmount');
            this.browser.localStorage?.removeItem('discountType');
          }
          if (response[this.firstObj]?.code === 200) {
            if (notifications && notifications?.length) {
              this.openNotificationDialog(notifications, proccedToCheckout);
            } else {
              this.router.navigate(['/checkout']);
            }
          } else {
            console.error(
              'Unexpected response code:',
              response[this.firstObj]?.code
            );
          }
        },
        error: (error) => {
          console.error('Error verifying cart:', error);
        },
      });
    } else {
      console.error('No order ID found in local storage');
    }
  }

  openNotificationDialog(notifications: string[], proccedToCheckout: boolean) {
    const dialogRef = this.dialog.open(CartVerifyPopupComponent, {
      data: { messages: notifications, totalItems: this.orderItemsData?.length, proccedToCheckout : proccedToCheckout },
    });
    dialogRef.afterClosed().subscribe(() => {
      scrollTo(0, 0);
    });
  }

  openSocialMediaLoginPopup(): void {
    this.goToLogin();
    this.browser.localStorage?.setItem('page', 'customer-login-modal');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    this.modalDialog = this.dialog.open(CustomerLoginComponent, dialogConfig);
    const currentUrl = this.router.url;
    if (currentUrl == '/cart') {
      this.modalDialog.afterClosed().subscribe(() => {
        this.reloadcartpage();
      });
    }
    if (currentUrl == '/checkout') {
      this.modalDialog.afterClosed().subscribe(() => {
        this.reloadcheckoutpage();
      });
    }
  }

  productRedirection(product_key: number): void {
    if (!product_key) {
      //  console.error('Product key is missing');
      return;
    }
    const product = this.orderItemsData?.find(
      (item) => item?.product_key === product_key
    );
    if (product && product?.product_name) {
      const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
      const productKey = product?.product_key;
      const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
      updatedProducts.unshift(productKey);
      this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
      this.commonService.productRedirection(product?.product_name, product_key);
    } else {
      console.error('Product name is missing or product not found');
    }
  }

  goToLogin() {
    const currentUrl = this.router.url;
    this.browser.localStorage?.setItem('redirectAfterLogin', currentUrl);
  }

  isLoggedIn(): boolean {
    return this.authHttpService.isLoggedIn();
  }

  calculatePromotion(): void {
    const promotionalPrices: number[] = [];
    const savedAmounts: number[] = [];
    const optionPrices = this.orderItemsData.map((item: any) => {
      const price = Number(item.option_price) || 0;
      return price;
    });
    optionPrices.forEach((price: number, index: number) => {
      let promotionalPrice: number;
      if (this.orderItemsData[index].promotion_type === 'percentage_discount') {
        promotionalPrice =
          price -
          price *
          (Number(this.orderItemsData[index].percentage_discount) / 100);
      } else if (
        this.orderItemsData[index].promotion_type === 'discount_flat_rate'
      ) {
        promotionalPrice = price - Number(this.orderItemsData[index].discount_flat_rate);
      } else {
        promotionalPrice = price;
      }
      promotionalPrice = parseFloat(promotionalPrice.toFixed(2));
      const savedAmount = parseFloat((price - promotionalPrice).toFixed(2));
      savedAmounts.push(savedAmount);
      promotionalPrices.push(promotionalPrice);
    });
    this.promotionalPrice = promotionalPrices;
    this.savedAmount = savedAmounts;
  }

  OnEmptyOrders() {
    this.browser.localStorage?.removeItem('checkoutArray');
    this.browser.localStorage?.removeItem('ItemCount');
    this.browser.localStorage?.removeItem('discountCode');
    this.browser.localStorage?.removeItem('discountedAmount');
    this.browser.localStorage?.removeItem('discountedValue');
    this.browser.localStorage?.removeItem('discountType');
    this.cartHttp.initializeOrderItemsList();
    this.cartHttp.setLocalStorageOrderItemsList();
    this.cartHttp.clearCartShippingType();
    this.browser.localStorage?.removeItem('orderQuantity');
    this.browser.localStorage?.removeItem('addToCartButtons');
  }

  ngOnDestroy() {
  if (!this.browser.isBrowser) return;
  const win = this.browser.window;
  const doc = this.browser.doc;
  if (!win || !doc) return;
  win.removeEventListener('open-shopping-cart', this.openCartListener);
  win.removeEventListener('hide.bs.offcanvas', this.hideCartListener);
  const cartOffcanvas = doc.getElementById('shoppingCartOffcanvas');
  if (cartOffcanvas) {
    cartOffcanvas.removeEventListener(
      'hide.bs.offcanvas',
      this.offcanvasHideListener
    );
  }
}
}